import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight, Lock, ShieldAlert } from "lucide-react";
import { api, setToken } from "../adminApi";

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [locked, setLocked] = useState(false);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const res = await api.login(username.trim(), password);
      setToken(res.token);
      navigate("/admin/projeler", { replace: true });
    } catch (err) {
      setError(err.message);
      setLocked(err.status === 429);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-[430px]">
        <div className="flex items-baseline gap-3 mb-10">
          <span className="display text-[30px] text-[#141414]">HRD</span>
          <span className="mono text-[9px] text-[#6B675F]">YÖNETİM PANELİ</span>
        </div>

        <div className="bg-white border border-[#E2E0D8] p-8 lg:p-10">
          <p className="mono text-[9px] text-[#8C7862] mb-6">[ GİRİŞ YAP ]</p>
          <h1 className="display text-[30px] text-[#141414] leading-[1.02]">
            Yönetici
            <br />
            girişi
          </h1>

          <form onSubmit={submit} className="mt-8 space-y-5">
            <div>
              <label className="mono text-[9px] text-[#6B675F] block mb-2">KULLANICI ADI</label>
              <input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
                data-testid="login-username"
                className="w-full h-12 px-4 bg-[#FAFAFA] border border-[#E2E0D8] text-[15px] text-[#141414] outline-none focus:border-[#C8B29B] transition-colors"
                placeholder="kullanıcı adınız"
              />
            </div>
            <div>
              <label className="mono text-[9px] text-[#6B675F] block mb-2">ŞİFRE</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                data-testid="login-password"
                className="w-full h-12 px-4 bg-[#FAFAFA] border border-[#E2E0D8] text-[15px] text-[#141414] outline-none focus:border-[#C8B29B] transition-colors"
                placeholder="••••••••"
              />
            </div>

            {error && (
              <div
                className={`flex items-start gap-3 border px-4 py-3 ${
                  locked ? "border-[#B4442F] bg-[#FBF1EE]" : "border-[#E2E0D8] bg-[#F7F6F2]"
                }`}
              >
                {locked ? (
                  <ShieldAlert size={15} strokeWidth={1.7} className="text-[#B4442F] mt-0.5 shrink-0" />
                ) : (
                  <Lock size={15} strokeWidth={1.7} className="text-[#8C7862] mt-0.5 shrink-0" />
                )}
                <p className={`text-[13px] leading-relaxed ${locked ? "text-[#8C2E1D]" : "text-[#141414]/75"}`}>
                  {error}
                </p>
              </div>
            )}

            <button
              type="submit"
              disabled={busy}
              data-testid="login-submit"
              className="w-full inline-flex items-center justify-center gap-2 bg-[#141414] text-[#FAFAFA] px-6 py-4 mono text-[10px] hover:bg-[#2A2A28] disabled:opacity-60 transition-colors duration-300"
            >
              {busy ? "KONTROL EDİLİYOR..." : "GİRİŞ YAP"} <ArrowUpRight size={14} strokeWidth={1.6} />
            </button>
          </form>

          <p className="mono text-[8.5px] text-[#A8A29A] mt-7 leading-relaxed">
            5 hatalı denemeden sonra giriş 10 dakika boyunca kilitlenir. Kimlik bilgileri sunucu
            ortam değişkenlerinde saklanır.
          </p>
        </div>
      </div>
    </div>
  );
}
